import { InjectionToken } from '@angular/core';

/**
 * Interface for providing the current customer ID.
 * Mirrors the IMarinaIdProvider pattern for customer-scoped data access.
 */
export interface ICustomerIdProvider {
  getCurrentCustomerId(): string | null;
}

/**
 * Injection token for the customer ID provider.
 * Provide it in each app module that serves customer-scoped requests.
 */
export const CUSTOMER_ID_PROVIDER = new InjectionToken<ICustomerIdProvider>('CUSTOMER_ID_PROVIDER');
